import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";
import { IBusiness, INotesViewModel } from "app/models/business/business";

import { BusinessService } from "app/services/business/business.service";
import { BusinessCommentsModalComponent } from "./businessCommentsModal.component";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'business-businessComments',
  templateUrl: './businessComments.component.html',
  styleUrls: ['./businessComments.component.scss']
})

export class BusinessCommentsComponent implements OnInit {

  @Input() businessId: number = 0;
  @Input() parentPanel: number = 0;

  sharedSubscription: Subscription;
  currentBusiness: IBusiness = {} as IBusiness;
  businessNotesList: INotesViewModel[] = [];
  complaintCount: number = 0;
  commentCount: number = 0;
  currentTab: number = 0;
  editBusinessFlag: boolean = false;
  businessName: string = '';

  displayedColumns: string[] = ['loggedDate', 'text', 'user'];
  dataSource = new MatTableDataSource<INotesViewModel>(this.businessNotesList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private complaintService: ComplaintService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    // if (this.parentPanel == 0) {
    //   this.sharedSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
    //     if (data == 2) {
    //       this.getComments();
    //     }
    //   });
    // } 
    // else {
      this.sharedSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
        if (data == 1) {
          this.getComments();
        }
      });
    // }
    this.businessId = this.businessService.businessId;
  }
  
  ngOnDestroy() {
    this.sharedSubscription.unsubscribe();
  }

  getComments() {
    this.businessId = this.businessService.businessId;
    this.businessService.getBusinessNotes(this.businessId).subscribe({
      next: response => {
        this.businessNotesList = response;
        this.dataSource.data = this.businessNotesList;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Business Notes Info");
      },
    });
  }

  add() {
    let config = new MatDialogConfig<any>();
    config.autoFocus = true;
    config.disableClose = false;
    config.minWidth = 800;
    config.data = { businessId: this.businessId };
    const dialogRef = this.modalService.open(BusinessCommentsModalComponent, config);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data == 'saved') {
          this.getComments();
          this.sharedService.toastr.success("Saved. ")
        }
      },
      error => this.sharedService.toastr.error("Could not add business comments: " + error.message),
      () => { }
    );
  }


}